import api from './api'
import type { Setting, SettingsResponse, SettingUpdate } from '@/types/settings'

export async function getSettings(): Promise<SettingsResponse> {
  const response = await api.get<SettingsResponse>('/settings')
  return response.data
}

export async function getSetting(key: string): Promise<Setting> {
  const response = await api.get<Setting>(`/settings/${key}`)
  return response.data
}

export async function updateSetting(key: string, data: SettingUpdate): Promise<Setting> {
  const response = await api.put<Setting>(`/settings/${key}`, data)
  return response.data
}

export async function deleteSetting(key: string): Promise<void> {
  await api.delete(`/settings/${key}`)
}
